import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: false,
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filterFn: (i: any) => boolean): any[] {
    if (!items) return [];
    if (!filterFn) return items;

    return items.filter(filterFn);
  }
}
